module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzOCAzOCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiNmZmY7b3BhY2l0eTowLjc1O30uY2xzLTJ7ZmlsbDojNjE1NjQ2O308L3N0eWxlPjwvZGVmcz48dGl0bGU+UEZLX0Fycm93X0xlZnQ8L3RpdGxlPjxjaXJjbGUgY2xhc3M9ImNscy0xIiBjeD0iMTkiIGN5PSIxOSIgcj0iMTkiLz48cGF0aCBjbGFzcz0iY2xzLTIiIGQ9Ik0yMi41OSwyNS42NmExLDEsMCwwLDAsLjU5LTEuODFMMTYuNCwxOWw2LjY3LTQuODFhMSwxLDAsMSwwLTEuMTctMS42MmwtNy44LDUuNjJhMSwxLDAsMCwwLDAsMS42MkwyMiwyNS40N0ExLDEsMCwwLDAsMjIuNTksMjUuNjZaIi8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PFK_Arrow_Carousel_Left.svg
// module id = 171
// module chunks = 2